import { useApolloClient } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";

import { DEFAULT_SEARCH_PARAMS } from "../../utils/complaintsConstants";
import { USER_ROUTES } from "../../utils/routeConstants";
import ComplaintsStatusSearch from "../ComplaintsStatusSearch/ComplaintsStatusSearch";
import ComplaintsStatusTable from "../ComplaintsStatusTable/ComplaintsStatusTable";
import { GlobContainer, Header } from "./ComplaintsStatusStyles";
import requestData from "./requestData";

// TODO: ask how get complaints without date restriction
function ComplaintStatus() {
  const [page, updatePage] = useState(0);
  const [numPages, updateNumPages] = useState(0);
  const [searchParams, updateSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
  const [currentSearchParams, updateCurrentSearchParams] = useState(
    DEFAULT_SEARCH_PARAMS
  );

  const client = useApolloClient();
  const [complaints, updateComplaints] = useState([]);

  const onComplaintsChange = (newArray) => {
    updateComplaints([...newArray]);
  };

  const makeRequest = useCallback(
    (page, searchParams, networkOnly = false) => {
      return requestData(client, page, searchParams, networkOnly).then(
        (response) => {
          updatePage(response.getAllDemand.page - 1);
          updateNumPages(response.getAllDemand.totalPages);
          onComplaintsChange(response.getAllDemand.docs);
        }
      );
    },
    [client]
  );

  useEffect(() => {
    makeRequest(1, DEFAULT_SEARCH_PARAMS, true);
  }, [makeRequest]);

  const onPageClick = (page) => {
    makeRequest(page + 1, currentSearchParams);
  };

  const clearSearchParams = () => {
    updateSearchParams(DEFAULT_SEARCH_PARAMS);
  };

  const searchHandler = (searchParams) => {
    makeRequest(1, searchParams).then(() => {
      updateCurrentSearchParams(searchParams);
    });
  };

  return (
    <GlobContainer>
      <Header> {USER_ROUTES.COMPLAINTS.title.toUpperCase()}</Header>
      <ComplaintsStatusSearch
        searchHandler={searchHandler}
        searchParams={searchParams}
        updateSearchParams={updateSearchParams}
      />
      <ComplaintsStatusTable
        complaints={complaints}
        pageHook={[page, updatePage]}
        numPages={numPages}
        onPageClick={onPageClick}
        clearSearchParams={clearSearchParams}
      />
    </GlobContainer>
  );
}

export default ComplaintStatus;
